import Fuse from "fuse.js";

// Fuzzy search across people, indexing problem-level fields with higher weight.
const OPTIONS = {
  includeScore: true,
  threshold: 0.4,
  ignoreLocation: true,
  minMatchCharLength: 2,
  keys: [
    { name: "name", weight: 0.3 },
    { name: "role", weight: 0.25 },
    { name: "bio", weight: 0.15 },
    { name: "location", weight: 0.05 },
    { name: "categories", weight: 0.4 },
    { name: "tools.name", weight: 0.4 },
    { name: "problems.title", weight: 0.7 },
    { name: "problems.description", weight: 0.5 },
    { name: "problems.outcome", weight: 0.5 },
    { name: "problems.tools", weight: 0.5 },
    { name: "problems.categories", weight: 0.5 },
  ],
};

let cached = { data: null, fuse: null };

export function fuzzySearch(people, query) {
  if (!query || !query.trim()) return people;
  if (cached.data !== people) {
    cached = { data: people, fuse: new Fuse(people, OPTIONS) };
  }
  return cached.fuse.search(query.trim()).map((r) => r.item);
}

// Problem-level filter: a person matches an active category/model/software-tool
// if it appears in ANY of their problems OR (for tools) on their profile.
// Falling back to profile-level tools means custom entries — which someone can
// submit to their profile before ever posting a matching problem — still
// return that person when a searcher filters by that tag.
export function filterByProblem(
  people,
  activeCategories,
  activeTools,
  activeSoftwareTools = []
) {
  if (
    !activeCategories.length &&
    !activeTools.length &&
    !activeSoftwareTools.length
  )
    return people;
  return people.filter((p) => {
    const matchesCat = !activeCategories.length
      ? true
      : (p.categories || []).some((c) => activeCategories.includes(c)) ||
        p.problems.some((pr) =>
          (pr.categories || []).some((c) => activeCategories.includes(c))
        );
    const matchesTool = !activeTools.length
      ? true
      : (p.tools || []).some((t) => activeTools.includes(t.name)) ||
        p.problems.some((pr) =>
          (pr.tools || []).some((t) => activeTools.includes(t))
        );
    const matchesSoftware = !activeSoftwareTools.length
      ? true
      : (p.software_tools || []).some((t) => activeSoftwareTools.includes(t));
    return matchesCat && matchesTool && matchesSoftware;
  });
}
